module.exports = __webpack_public_path__ + "img/valve_bag.9e2aa3d9.png";